import React, { useReducer } from 'react';
import propTypes from 'prop-types';
import css from 'classnames';

import useWidgetLayout from '../../hooks/useWidgetLayout';
import FormContext from '../context/formContext';
import reducer, { initialState } from '../../reducer';
import Form from '../form';

import styles from './car-calculator.module.css';

const CarCalculator = ({ title, bgWhite, tagline, theme, gtm }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  // Get widget width, used for dynamic styling of elements. The dynamic styling
  // doesn't use media queries, because the form needs to visually respond to its
  // container-width and not to the size of the viewport.
  const orientation = useWidgetLayout();

  return (
    <FormContext.Provider value={{ state, dispatch }}>
      <div
        className={css({
          [styles.container]: true,
          [styles.wc]: theme === 'wc',
          [styles.ac]: theme === 'ac',
          [styles.bgWhite]: bgWhite,
          [styles[orientation]]: !!orientation,
        })}
      >
        {title && <h1 className={styles.heading}>{title}</h1>}
        <p className={styles.tagline}>{tagline}</p>
        <Form gtm={gtm} />
      </div>
    </FormContext.Provider>
  );
};

CarCalculator.defaultProps = {
  tagline:
    'Select from the drop downs below to calculate the cost of your company car.',
  theme: 'wc',
};

CarCalculator.propTypes = {
  title: propTypes.string,
  tagline: propTypes.string,
  bgWhite: propTypes.bool,
  bgGrey: propTypes.bool,
  theme: propTypes.string,
  gtm: propTypes.func,
};

export default CarCalculator;
